const state = {
    orderInfo: {
        code: "sh-hosp6",
        package: {
            id: "",
            name: "",
        },
        appointDate: "",
        appointTime: "",

    },
    userProfile: {
        id: "",
    },
}

const mutations = {
    SET_ORDER(state, data) {
        state.orderInfo = data.orderInfo;
    }
}

const actions = {
    addOrder(store, data) {
        store.commit("SET_ORDER", data); //调用mutation需要用commit方法
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}